__turbopack_context__.v({
  "root": "Container-module__xRBGLW__root",
});
